import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const { isAuthenticated, logout } = useAuth();

  return (
    <header className="navbar">
      <div className="navbar-logo">
        <Link to="/">Verifier</Link>
      </div>
      <div className="navbar-actions">
        {isAuthenticated ? (
          <button onClick={logout} className="logout-button">Logout</button>
        ) : (
          <button onClick={() => window.location.href = '/login'} className="login-button">
            Login
          </button>
        )}
      </div>
    </header>
  );
};

export default Navbar;
